/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE */
export interface EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventAdditionalPatientInformationValueEventTypeEnum;
	event_data: EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE_DATA;
}

/** EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE_DATA */
export interface EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string;
	/** Experiment Name */
	experiment_name?: string;
	/** First Name */
	first_name?: string;
	/** Last Name */
	last_name?: string;
	/** Date Of Birth */
	date_of_birth?: string;
	/** Email Address */
	email_address?: string;
	/** Mobile Phone */
	mobile_phone?: string;
	/** Home Phone */
	home_phone?: string;
	/** Is Insured */
	is_insured?: boolean;
	/** Client Id */
	client_id?: string;
}

/** EVENT_APPOINTMENTS_RETURNED_VALUE */
export interface EVENT_APPOINTMENTS_RETURNED_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventAppointmentsReturnedValueEventTypeEnum;
	event_data: EVENT_APPOINTMENTS_RETURNED_VALUE_DATA;
}

/** EVENT_APPOINTMENTS_RETURNED_VALUE_DATA */
export interface EVENT_APPOINTMENTS_RETURNED_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string;
	/** Experiment Name */
	experiment_name?: string;
	/** Visit Reason */
	visit_reason?: string;
	/** Visit Reason Subtype */
	visit_reason_subtype?: string;
	/** Client Id */
	client_id?: string;
}

/** EVENT_APPOINTMENT_VALUE */
export type EVENT_APPOINTMENT_VALUE =
	| EVENT_NEW_APPOINTMENT_VALUE
	| EVENT_REASON_FOR_VISIT_VALUE
	| EVENT_REASON_RESPONSE_VALUE
	| EVENT_FIRST_DENTURE_RESPONSE_VALUE
	| EVENT_APPOINTMENTS_RETURNED_VALUE
	| EVENT_PATIENT_INFORMATION_VALUE
	| EVENT_ADDITIONAL_PATIENT_INFORMATION_VALUE
	| EVENT_REVIEW_APPOINTMENT_VALUE
	| EVENT_SUBMIT_ASSESSMENT_VALUE
	| EVENT_MOTTO_POPUP_VALUE;

/** EVENT_FIRST_DENTURE_RESPONSE_VALUE */
export interface EVENT_FIRST_DENTURE_RESPONSE_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventFirstDentureResponseValueEventTypeEnum;
	event_data: EVENT_FIRST_DENTURE_RESPONSE_VALUE_DATA;
}

/** EVENT_FIRST_DENTURE_RESPONSE_VALUE_DATA */
export interface EVENT_FIRST_DENTURE_RESPONSE_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string;
	/** Experiment Name */
	experiment_name?: string;
	/** Visit Reason */
	visit_reason?: string;
	/** Visit Reason Subtype */
	visit_reason_subtype?: string;
	/** Client Id */
	client_id?: string;
}

/** EVENT_MOTTO_POPUP_VALUE */
export interface EVENT_MOTTO_POPUP_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventMottoPopupValueEventTypeEnum;
	event_data: EVENT_MOTTO_POPUP_VALUE_DATA;
}

/** EVENT_MOTTO_POPUP_VALUE_DATA */
export interface EVENT_MOTTO_POPUP_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** First Name */
	first_name: string;
	/** Email Address */
	email_address: string;
	/** Last Name */
	last_name?: string;
	/** Date Of Birth */
	date_of_birth?: string;
	/** Zip Code */
	zip_code?: string;
	/** Visit Reason */
	visit_reason?: string;
	/** Mobile Phone */
	mobile_phone?: string;
	/** Home Phone */
	home_phone?: string;
	/** Is Insured */
	is_insured?: boolean;
	/** Client Id */
	client_id?: string;
}

/** EVENT_NEW_APPOINTMENT_VALUE */
export interface EVENT_NEW_APPOINTMENT_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventNewAppointmentValueEventTypeEnum;
	event_data: EVENT_NEW_APPOINTMENT_VALUE_DATA;
}

/** EVENT_NEW_APPOINTMENT_VALUE_DATA */
export interface EVENT_NEW_APPOINTMENT_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Uri Query String */
	uri_query_string: string;
	/** Facility Code */
	facility_code?: string;
	/** Client Id */
	client_id?: string;
}

/** EVENT_PATIENT_INFORMATION_VALUE */
export interface EVENT_PATIENT_INFORMATION_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventPatientInformationValueEventTypeEnum;
	event_data: EVENT_PATIENT_INFORMATION_VALUE_DATA;
}

/** EVENT_PATIENT_INFORMATION_VALUE_DATA */
export interface EVENT_PATIENT_INFORMATION_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string;
	/** Experiment Name */
	experiment_name?: string;
	/** First Name */
	first_name?: string;
	/** Last Name */
	last_name?: string;
	/** Date Of Birth */
	date_of_birth?: string;
	/** Client Id */
	client_id?: string;
}

/** EVENT_REASON_FOR_VISIT_VALUE */
export interface EVENT_REASON_FOR_VISIT_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventReasonForVisitValueEventTypeEnum;
	event_data: EVENT_REASON_FOR_VISIT_VALUE_DATA;
}

/** EVENT_REASON_FOR_VISIT_VALUE_DATA */
export interface EVENT_REASON_FOR_VISIT_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string;
	/** Experiment Name */
	experiment_name?: string;
	/** Client Id */
	client_id?: string;
}

/** EVENT_REASON_RESPONSE_VALUE */
export interface EVENT_REASON_RESPONSE_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventReasonResponseValueEventTypeEnum;
	event_data: EVENT_REASON_RESPONSE_VALUE_DATA;
}

/** EVENT_REASON_RESPONSE_VALUE_DATA */
export interface EVENT_REASON_RESPONSE_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string;
	/** Experiment Name */
	experiment_name?: string;
	/** Visit Reason */
	visit_reason?: string;
	/** Client Id */
	client_id?: string;
}

/** EVENT_REVIEW_APPOINTMENT_VALUE */
export interface EVENT_REVIEW_APPOINTMENT_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventReviewAppointmentValueEventTypeEnum;
	event_data: EVENT_REVIEW_APPOINTMENT_VALUE_DATA;
}

/** EVENT_REVIEW_APPOINTMENT_VALUE_DATA */
export interface EVENT_REVIEW_APPOINTMENT_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string;
	/** Experiment Name */
	experiment_name?: string;
	/** First Name */
	first_name?: string;
	/** Last Name */
	last_name?: string;
	/** Date Of Birth */
	date_of_birth?: string;
	/** Email Address */
	email_address?: string;
	/** Mobile Phone */
	mobile_phone?: string;
	/** Home Phone */
	home_phone?: string;
	/** Is Insured */
	is_insured?: boolean;
	/** Visit Reason */
	visit_reason?: string;
	/** Visit Reason Subtype */
	visit_reason_subtype?: string;
	/** Appointment Start */
	appointment_start?: string;
	/** Appointment End */
	appointment_end?: string;
	/** Client Id */
	client_id?: string;
}

/** EVENT_SUBMIT_ASSESSMENT_VALUE */
export interface EVENT_SUBMIT_ASSESSMENT_VALUE {
	/**
	 * Timestamp
	 * @pattern ^(?:[0-9]{4}-[0-9]{2}-[0-9]{2})?(?:[ T][0-9]{2}:[0-9]{2}:[0-9]{2})?(?:[.,][0-9]{0,6})?Z$
	 */
	timestamp: string;
	/** Event Type */
	event_type: EventSubmitAssessmentValueEventTypeEnum;
	event_data: EVENT_SUBMIT_ASSESSMENT_VALUE_DATA;
}

/** EVENT_SUBMIT_ASSESSMENT_VALUE_DATA */
export interface EVENT_SUBMIT_ASSESSMENT_VALUE_DATA {
	/** Session Id */
	session_id: string;
	/** Facility Code */
	facility_code?: string;
	/** Age Demographic */
	age_demographic: string;
	/** Consideration Reason */
	consideration_reason: string;
	/**
	 * Previous Ortho Appliance
	 * @pattern ^(?i)(true|false)$
	 */
	previous_ortho_appliance: string;
	/** Type Of Insurance */
	type_of_insurance: string;
	/** Teeth Crowding Severity */
	teeth_crowding_severity: string;
	/** Teeth Spacing Severity */
	teeth_spacing_severity: string;
	/** First Name */
	first_name: string;
	/** Last Name */
	last_name: string;
	/** Email Address */
	email_address: string;
	/** Zip Code */
	zip_code: string;
	/** Client Id */
	client_id?: string;
}

/** HTTPValidationError */
export interface HTTPValidationError {
	/** Detail */
	detail?: ValidationError[];
}

/** ValidationError */
export interface ValidationError {
	/** Location */
	loc: (string | number)[];
	/** Message */
	msg: string;
	/** Error Type */
	type: string;
}

/** Event Type */
export enum EventAdditionalPatientInformationValueEventTypeEnum {
	AdditionalPatientInfo = 'additional_patient_info',
}

/** Event Type */
export enum EventAppointmentsReturnedValueEventTypeEnum {
	AvailableAppointmentsReturned = 'available_appointments_returned',
}

/** Event Type */
export enum EventFirstDentureResponseValueEventTypeEnum {
	FirstTimeDentureResponse = 'first_time_denture_response',
}

/** Event Type */
export enum EventMottoPopupValueEventTypeEnum {
	MottoAbandonedPopup = 'motto_abandoned_popup',
}

/** Event Type */
export enum EventNewAppointmentValueEventTypeEnum {
	ScheduleAnAppointment = 'schedule_an_appointment',
}

/** Event Type */
export enum EventPatientInformationValueEventTypeEnum {
	PatientInfo = 'patient_info',
}

/** Event Type */
export enum EventReasonForVisitValueEventTypeEnum {
	ReasonForVisit = 'reason_for_visit',
}

/** Event Type */
export enum EventReasonResponseValueEventTypeEnum {
	ReasonForVisitResponse = 'reason_for_visit_response',
}

/** Event Type */
export enum EventReviewAppointmentValueEventTypeEnum {
	AppointmentReview = 'appointment_review',
}

/** Event Type */
export enum EventSubmitAssessmentValueEventTypeEnum {
	SubmitSmileAssessment = 'submit_smile_assessment',
}
